import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FieldWrapper, Text } from '@dixa/lib-shared-habla';
import { useFormContext } from 'react-hook-form';
import { HookFormSwitch } from 'components/hookForm';
const genericDescription = 'To ensure you have comprehensive data to further reporting.';
const entityDescription = {
    conversation: `${genericDescription} It only applies to claimed conversations. When required, wrap-up time will not stop until this attribute is filled in by the agent. The conversation will remain on the left-side bar until then for agents to find them.`,
};
/** Represents the field for setting the required state of a custom attribute. */
export const RequiredFormField = ({ entityId, }) => {
    var _a;
    const { control,
    // TODO: [TEAMS-13693] remove omit after updating to RHF v8
     } = useFormContext();
    return (_jsxs(FieldWrapper, Object.assign({ label: "Required for agents to fill", labelFor: "is_required" }, { children: [_jsx(Box, Object.assign({ padding: "0 0 250" }, { children: _jsx(Text.Paragraph, Object.assign({ variant: "4", subdued: true }, { children: (_a = entityDescription[entityId]) !== null && _a !== void 0 ? _a : genericDescription })) })), _jsx(HookFormSwitch, { control: control, name: "is_required" })] })));
};
